// Client calls of the multi-tenant package "bizcal" — the firm's business calendar / billing & reminders policy.
import { apiRequest } from '../api';

export type PolicyKey =
  | 'billingDay' | 'invoiceDueDay' | 'quotationValidDays' | 'paymentReminderDays' | 'paymentEscalateDays'
  | 'complianceReminderDays' | 'taskReminderDays' | 'clientDataDay' | 'bookkeepingDay' | 'clientTaxPaymentDay'
  | 'schedulePayrollDay' | 'scheduleTaxFromDay' | 'leadInfoDays' | 'leadQuotationDays' | 'leadContractDays'
  | 'jobReminderLeadDays' | 'jobReminderRenewalLeadDays' | 'jobReminderReportLeadDays'
  | 'trialDays' | 'trialReferralDays' | 'trialDocLimit' | 'trialNoticeDays'
  | 'pettyMatchDelayMinutes' | 'pettyJobDelayMinutes' | 'pendingReceiptDays'
  | 'propTaxFee' | 'propTaxDueMmdd';   // property tax (package proptax): no product default → null = not set
export type FirmPolicy = Record<PolicyKey, number | number[] | string | null>;
export type PolicyGroup = 'billing' | 'reminders' | 'calendar' | 'onboarding' | 'jobs' | 'trial' | 'petty' | 'proptax';
export type PolicyField = { key: PolicyKey; kind: 'day' | 'number' | 'list' | 'amount' | 'mmdd'; min: number; max: number; group: PolicyGroup };
export type PolicyAdmin = { fields: PolicyField[]; defaults: FirmPolicy; own: Record<PolicyKey, string>; effective: FirmPolicy };

/** The effective policy of a company (product defaults when it has none / no id). */
export const bizcalPolicy = (companyId?: string): Promise<FirmPolicy> =>
  apiRequest('GET', `/bizcal/policy${companyId ? `?companyId=${encodeURIComponent(companyId)}` : ''}`);
export const bizcalAdminGet = (companyId: string): Promise<PolicyAdmin> =>
  apiRequest('GET', `/bizcal/admin/${encodeURIComponent(companyId)}`);
export const bizcalAdminSave = (companyId: string, patch: Partial<Record<PolicyKey, string>>): Promise<{ own: Record<PolicyKey, string>; effective: FirmPolicy }> =>
  apiRequest('PUT', `/bizcal/admin/${encodeURIComponent(companyId)}`, patch);
